var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crumbs"},[_c('span',{staticClass:"direct-tip"},[_vm._v("当前位置：")]),_vm._v(" "),_c('a',{staticClass:"direct-dir",attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.trail))]),_vm._v(" "),_c('span',{staticClass:"direct-sub-dir"},[_vm._v(_vm._s(_vm.subTrail))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-7177501e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/crumbs/crumbs.vue
// module id = null
// module chunks = 